module.exports = __webpack_public_path__ + "static/media/board.7a6968e8.png";